import { createSelector } from 'reselect';
import studentCohortFiltersSelector from './student_cohort_filters_selector';

const studentRatios = {
  safe: 'abl-student-ratio-safe',
  nearLimit: 'abl-student-ratio-near-limit',
  aboveLimit: 'abl-student-ratio-above-limit'
};

const studentCohortCardSelector = createSelector(
  state => state,
  state => studentCohortFiltersSelector.getFilter(state),
  state => studentCohortFiltersSelector.getAll(state),
  state => studentCohortFiltersSelector.filterStudents(state),

  (state, filter, filters, filteredStudents) => {
    let capacity = 24;
    
    return {
      capacity: `${capacity} Students`,
      studentRatio: studentRatios.nearLimit,
      filterClassName: filter ? filter.selectedClass : null,
      filteredStudents: filteredStudents,
      filters: filters
    }
  }
);

export default studentCohortCardSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/student_cohort_card_selector.js
 **/